<template>
	<lcsj-dialog v-model="showDialog" title="报销单详情" width="1200px" append-to-body cancel-text="关闭">
		<detail ref="detail"></detail>
		
	</lcsj-dialog>
</template>
<script>
import detail from "./detail.vue";
export default {
	props: [],
	data() {
		return {
			showDialog: false
		};
	},
	components: {
		detail
	},
	created() {},
	methods: {
		getDetailDialog(row) {
			this.showDialog = true;
			this.$nextTick(() => {
				this.$refs.detail.getDetail(row);
			});
		},
		closeDialog() {
			this.showDialog = false;
		}
	}
};
</script>
<style scoped lang="scss"></style>
